import React, { useState, useEffect, useRef } from "react"
import { useDispatch, useSelector } from "react-redux"
import { showAlertAction, hideAlertAction, hideAlert } from "../../actions/alertActions"
import { requestLoadConceptFromAPI, setUnsaveFlag } from "../../actions/buildconceptActions"
import { setCurrentSearchAction, setCurrentSearch } from "../../actions/currentSearchActions"
import { clearRequestSearch, setSelectedSearch } from "../../actions/searchActions"
import { setSearchLoad, deleteSearchLoad, saveNewSearch } from "../../actions/savedSearchActions"
// eslint-disable-next-line
import ModalAnzyz from "../ModalAnzyz"
// eslint-disable-next-line
import SimplePopover from "../build/btnInfo"
import Autocomplete from "@material-ui/lab/Autocomplete"
import { makeStyles } from "@material-ui/core/styles"
import TextField from "@material-ui/core/TextField"
import InfoDialog from "../common/InfoDialog"
import uuid from "react-uuid"
import SavedSearches from "../common/SavedSearches"
import SaveNewSearch from "../common/SaveNewSearch"
// Translations
import { useTranslation } from "react-i18next"
import { setAIBase } from "../../actions/multiAiBase"
import { Col, Row } from "react-bootstrap"

const SearchBox = ({
	createSearch,
	saveConceptBuilder,
	border,
	setBorder,
	popups,
	setPopups,
	setUpdateFiletypes,
	setFilterList,
	filterList,
	setFileTypesRefresh,
	docCount,
}) => {
	/* ******************* TRANSALATIONS ******************* */
	const [t, i18n] = useTranslation("global")
	/* ******************* END TRANSALATIONS ******************* */

	/* ******************* USER INFO ******************* */
	const userDetails = JSON.parse(localStorage.getItem("user"))
	/* ******************* END USER INFO ******************* */

	/* ******************* REDUX STORE ******************* */
	// Get inputs results
	const dispatch = useDispatch()
	const savedConceptList = useSelector((state) => state.buildconcept.user_saved_build_concepts)
	const loadedAPIData = useSelector((state) => state.buildconcept.loadedAPIData)
	const isUnsavedDate = useSelector((state) => state.buildconcept.unsaved_data)
	const lastestSearch = useSelector((state) => state.currentSearchs.search)
	const lastSearch = useSelector((state) => state.savedSearch.savedSearchs)
	const savedSearches = useSelector((state) => state.savedSearch.savedSearchs)
	const idSearch = useSelector((state) => state.search.searchResults.id_search)
	const selectedBaseId = useSelector((state) => state.multiBase.selectedBase.project_id)
	const selectedSearch = useSelector((state) => state.savedSearch?.selectedSearch)
	const selectedBase = useSelector((state) => state.multiBase.selectedBase)
	const prevSelectedId = selectedBase.prev
	/* ******************* END REDUX STORE ******************* */

	/* ******************* REACT STATES ******************* */
	// Component states
	const [inputSearch, updateInputSearch] = useState(lastestSearch.text)
	const [inputSaveConcept, updateInputSaveConcept] = useState("")
	const [inputLoadSearch, updateInputLoadSearch] = useState("")
	// eslint-disable-next-line
	const [modalUnsavedChanges, setModalUnsavedChanges] = useState(false)
	// eslint-disable-next-line
	const [modalCancelChanges, setModalCancelChanges] = useState(false)

	//Autocomplete state
	const [valueAutocomplete, setValueAutocomplete] = useState(lastestSearch.concepts)
	// eslint-disable-next-line
	const [inputValueAutocomplete, setInputValueAutocomplete] = useState("")
	//Show or hide Saved Build Concept List
	// eslint-disable-next-line
	const [showSavedList, setShowSavedList] = useState(false)
	//Show or hide Save Button
	//Show saved query input
	const [showToSaveForm, setShowToSaveForm] = useState(false)
	//Show saved query detail
	const [showSaveQueryDetail, setShowSaveQueryDetail] = useState("")
	//Data for saved query
	const [saveQueryData, setSaveQueryData] = useState({
		name: "",
		share: 0,
		id: "",
	})

	// eslint-disable-next-line
	const [showSaveButton, setShowSaveButton] = useState(false)
	// Pagination
	const [currentpageSavedConcepts, setCurrentPageSavedConcepts] = useState(1)
	// eslint-disable-next-line
	const [totalpagesSavedConcepts, setTotalPagesSavedConcepts] = useState(1)
	const [currentpageSharedConcepts, setCurrentPageSharedConcepts] = useState(1)
	// eslint-disable-next-line
	const [totalpagesSharedConcepts, setTotalPagesSharedConcepts] = useState(1)
	// Clear Search State
	const [clearSearch, setClearSearch] = useState(false)
	// Refresh Autocomplet Element for deleting tags
	const [autoCompleteRefresh, setAutoCompleteRefresh] = useState(0)
	// Refresh Share checkbox Element for deleting tags
	const [shareRefresh, setShareRefresh] = useState(0)

	// Save search for local storage
	/*const [searchReducer, setSearchReducer] = useState({
    inputSearch: '',
    valueAutocomplete: '',
    date: ''
  });*/

	const [queryNameValue, setQueryNameValue] = useState("")
	/* ******************* END REACT STATES ******************* */

	/* ******************* USE-EFFECTS ******************* */
	/*useEffect(() => {
    dispatch(setSearchLoad(searchReducer));
  }, [searchReducer])
  */

	useEffect(() => {
		return () => {
			dispatch(setSelectedSearch(undefined)) //on unmount Selected Search set to undefined
		}
	}, [])

	useEffect(() => {
		if (selectedBaseId !== prevSelectedId) {
			updateClearSearch(false)
			dispatch(setAIBase({ ...selectedBase, prev: selectedBaseId }))
		}
	}, [selectedBaseId])

	useEffect(() => {
		if (lastSearch && lastSearch.length === 0) {
			setShowSavedList(false)
		}
	}, [lastSearch])
	useEffect(() => {
		if (border === true) {
			let element = document.getElementById("inputSearch")
			element.classList.add("inputBorder")
			element.focus()
		} else {
			let element = document.getElementById("inputSearch")
			element.classList.remove("inputBorder")
		}
	}, [border])

	useEffect(() => {
		//Refrech the save field with the current concept name
		if (loadedAPIData.description) {
			updateInputSaveConcept(loadedAPIData.description)
		}
		return
	}, [loadedAPIData.description])

	//Update number of elements shown in list
	useEffect(() => {
		var elements = document.getElementsByClassName("conceptLoaded")
		for (var i = 0; i < elements.length; i++) {
			if (elements[i].classList.contains("conceptLoaded_page_" + currentpageSavedConcepts) === true) {
				elements[i].classList.remove("hidePage")
			} else {
				elements[i].classList.add("hidePage")
			}
		}
	}, [currentpageSavedConcepts])

	useEffect(() => {
		var elements = document.getElementsByClassName("conceptShared")
		for (var i = 0; i < elements.length; i++) {
			if (elements[i].classList.contains("conceptShared_page_" + currentpageSharedConcepts) === true) {
				elements[i].classList.remove("hidePage")
			} else {
				elements[i].classList.add("hidePage")
			}
		}
	}, [currentpageSharedConcepts])

	// Reset lastestSearch.text to empty
	useEffect(() => {
		//dispatch(setCurrentSearchAction(inputSearch, valueAutocomplete, "search"));
		dispatch(setCurrentSearch(inputSearch, valueAutocomplete, "search"))
	}, [clearSearch])

	useEffect(() => {
		let element = document.getElementById("clearButton")
		if (valueAutocomplete) {
			if (valueAutocomplete.length > 0 || !!inputSearch) {
				element.classList.remove("disabled")
				element.classList.add("showClearButton")
			} else {
				element.classList.remove("showClearButton")
				element.classList.add("disabled")
			}
		}
	}, [valueAutocomplete])

	useEffect(() => {
		setAutoCompleteRefresh(Math.random())
	}, [lastestSearch.concepts])
	/* ******************* END USE-EFFECTS ******************* */

	/* ******************* CUSTOM FUNCTIONS ******************* */
	// Save new Search
	const saveSearch = () => {
		let userId = userDetails.id
		let continueSaving = true
		if (savedSearches && savedSearches.length > 0) {
			savedSearches.forEach((element) => {
				if (element.search_name === saveQueryData.name) {
					if (saveQueryData.share != element.params.published) {
						setSearchDelete(element.search_id)
					} else {
						alert("The name entered to save the search is currently in use. Please, choose another name to continue")
						continueSaving = false
					}
				}
			})
		}

		if (continueSaving === true) {
			let searchUUID
			// if (saveQueryData.id === ""){
			//   searchUUID=uuid();
			//   setSaveQueryData({...saveQueryData, id: searchUUID});
			// }else{
			//   searchUUID=saveQueryData.id;
			// }

			let newSearch = {
				name: saveQueryData.name,
				search_id: searchUUID,
				docs_count: docCount,
				params: {
					text: inputSearch,
					categories: valueAutocomplete,
					source: filterList,
					return_count: 10,
					skip_count: 0,
					dynamic_search: 0,
					published: saveQueryData.share,
					suppress_content: false,
					mark_dates: 0,
					mark_emails: 0,
					//creation_time: new Date()
				},
			}
			const selectedConceptsIdList = valueAutocomplete.map((conceptObj) => conceptObj.id)
			let newSearchToSave = {
				name: saveQueryData.name,
				owner_id: userId,
				shared: saveQueryData.share,
				id: selectedSearch?.id,
				docs_count: docCount,
				params: {
					text: inputSearch,
					categories: selectedConceptsIdList,
					return_count: 10,
					dynamic_search: 0,
					source: filterList,
					skip_count: 0,
					suppress_content: false,
				},
			}
			// dispatch(saveNewSearch(newSearch));
			dispatch(saveNewSearch(newSearchToSave))

			const alert1 = {
				msg: "Search saved!",
				class: "alert alert-dismissible alert-success",
			}
			dispatch(showAlertAction(alert1))
			setTimeout(function () {
				try {
					dispatch(hideAlertAction())
				} catch (e) {}
			}, 5000)
		}
	}

	// Delete search
	const setSearchDelete = (idSearch) => {
		dispatch(deleteSearchLoad(idSearch))
		if (selectedSearch.id === idSearch) {
			//if selectedSearch and idSearch is same then clear the current view
			updateClearSearch(true)
		}
	}

	// Save search
	// const setSearchReducer = () => {
	//   // dispatch(setSearchLoad({
	//   //   id: (saveQueryData.id===""? uuid():saveQueryData.id),
	//   //   inputSearch: inputSearch,
	//   //   valueAutocomplete: valueAutocomplete,
	//   //   date: Date.now(),
	//   //   name: saveQueryData.name,
	//   //   share: saveQueryData.share
	//   // }));

	//   dispatch(
	//     setSearchLoad({
	//       id: saveQueryData.id === "" ? uuid() : saveQueryData.id,
	//       inputSearch: inputSearch,
	//       valueAutocomplete: valueAutocomplete,
	//       date: Date.now(),
	//       name: saveQueryData.name,
	//       params: {
	//         categories: [],
	//         dynamic_search: 0,
	//         mark_dates: 0,
	//         mark_emails: 0,
	//         published: saveQueryData.share,
	//         return_count: 0,
	//         skip_count: 0,
	//         source: [],
	//         supress_content: false,
	//         text: inputSearch,
	//       },
	//       search_id: saveQueryData.id,
	//       search_name: saveQueryData.name,
	//     })
	//   );
	// };

	// Clear function
	const updateClearSearch = (shouldStoreUpdate) => {
		setClearSearch(true)
		setSaveQueryData({ name: "", share: 0, id: "" })
		dispatch(setSelectedSearch(undefined))
		setShareRefresh(Math.random())
		setShowToSaveForm(false)
		updateInputSearch("")
		setValueAutocomplete([])
		let element = document.getElementById("clearButton")
		element.classList.remove("showClearButton")
		element.classList.add("disabled")
		if (shouldStoreUpdate) dispatch(clearRequestSearch())
		setAutoCompleteRefresh(Math.floor(Math.random() * 10000))
	}

	// Input function
	const updateSearch = (e) => {
		updateInputSearch(e.target.value)
		let element = document.getElementById("clearButton")
		if (e.target.value !== "") {
			element.classList.remove("disabled")
			element.classList.add("showClearButton")
		} else {
			element.classList.remove("showClearButton")
			element.classList.add("disabled")
		}
	}

	// eslint-disable-next-line
	const updateSaveConcept = (e) => {
		updateInputSaveConcept(e.target.value)
	}
	// eslint-disable-next-line
	const updateLoadSearch = (e) => {
		updateInputLoadSearch(e.target.value)
	}

	// eslint-disable-next-line
	let continueAfterModal = () => {
		dispatch(setUnsaveFlag(false))
		forceSearch()
	}
	// Form submitted
	const submitSearchForm = (e) => {
		e.preventDefault()

		// Form validation or other function.
		if (inputSearch.trim() === "" && valueAutocomplete.length === 0) {
			//Error, there is nothing type to search
			const alert1 = {
				msg: "Please type some text or select one or more concepts to start exploring",
				class: "alert alert-danger",
			}
			dispatch(showAlertAction(alert1))
			return
		}

		//Check if unsaved data
		if (isUnsavedDate) {
			setModalUnsavedChanges(true)
			continueAfterModal = () => {
				dispatch(setUnsaveFlag(false))
				forceSearch()
			}
			return
		}

		forceSearch()
	}

	const forceSearch = () => {
		setModalUnsavedChanges(false)
		// Create Filter
		dispatch(hideAlertAction())
		dispatch(setCurrentSearchAction(inputSearch, valueAutocomplete, "search"))
		createSearch(inputSearch, valueAutocomplete)
		updateInputSaveConcept("")
		if (showSaveButton == false) {
			setShowSaveButton(!showSaveButton)
		}
	}
	// eslint-disable-next-line
	const submitSaveForm = (e) => {
		e.preventDefault()

		// Form validation or other function.
		if (inputSaveConcept.trim() === "") {
			//Error, there is nothing type to search
			const alert1 = {
				msg: "Please type a name to save the concept",
				class: "alert alert-danger",
			}
			dispatch(showAlertAction(alert1))
			return
		}
		dispatch(hideAlertAction())
		saveConceptBuilder(inputSaveConcept)
	}

	// Filtering savedConceptList result
	// eslint-disable-next-line
	// const filtered = savedConceptList.filter((item) => {
	//   return item.description.indexOf(inputLoadSearch) !== -1;
	// });

	//Previous Page
	// eslint-disable-next-line
	const prevPageSavedConcepts = () => {
		const newCurrentPageSavedConcepts = currentpageSavedConcepts - 1
		if (newCurrentPageSavedConcepts === 0) return
		setCurrentPageSavedConcepts(newCurrentPageSavedConcepts)
	}
	// eslint-disable-next-line
	const prevPageSharedConcepts = () => {
		const newCurrentPageSharedConcepts = currentpageSharedConcepts - 1
		if (newCurrentPageSharedConcepts === 0) return
		setCurrentPageSharedConcepts(newCurrentPageSharedConcepts)
	}

	// Next Page
	// eslint-disable-next-line
	const nextPageSavedConcepts = () => {
		const newCurrentPageSavedConcepts = currentpageSavedConcepts + 1
		if (newCurrentPageSavedConcepts > totalpagesSavedConcepts) return
		setCurrentPageSavedConcepts(newCurrentPageSavedConcepts)
	}
	// eslint-disable-next-line
	const nextPageSharedConcepts = () => {
		const newCurrentPageSharedConcepts = currentpageSharedConcepts + 1
		if (newCurrentPageSharedConcepts > totalpagesSharedConcepts) return
		setCurrentPageSharedConcepts(newCurrentPageSharedConcepts)
	}

	// eslint-disable-next-line
	const loadSavedContent = (ext_id) => {
		//Check if unsaved data
		if (isUnsavedDate) {
			setModalUnsavedChanges(true)
			continueAfterModal = () => {
				dispatch(setUnsaveFlag(false))
				loadSavedContent(ext_id)
			}
			return
		}
		dispatch(requestLoadConceptFromAPI(ext_id))
	}

	// Autocomplete - Search in Concept
	const useStyles = makeStyles((theme) => ({
		root: {
			width: 600,
			"& > * + *": {
				marginTop: theme.spacing(2),
			},
		},
	}))

	// OUTSIDE ALERTER
	/**
	 * Hook that alerts clicks outside of the passed ref
	 */
	const useOutsideAlerter = (ref) => {
		useEffect(() => {
			/**
			 * Alert if clicked on outside of element
			 */
			function handleClickOutside(event) {
				if (ref.current && !ref.current.contains(event.target)) {
					setPopups({
						showLoadConcepts: false,
					})
					setShowSavedList(false)
				}
			}

			// Bind the event listener
			document.addEventListener("mousedown", handleClickOutside)
			return () => {
				// Unbind the event listener on clean up
				document.removeEventListener("mousedown", handleClickOutside)
			}
		}, [ref])
	}
	const useOutsideAlerterSave = (ref) => {
		useEffect(() => {
			/**
			 * Alert if clicked on outside of element
			 */
			function handleClickOutside(event) {
				if (ref.current && !ref.current.contains(event.target)) {
					setShowToSaveForm(false)
				}
			}

			// Bind the event listener
			document.addEventListener("mousedown", handleClickOutside)
			return () => {
				// Unbind the event listener on clean up
				document.removeEventListener("mousedown", handleClickOutside)
			}
		}, [ref])
	}

	const loadSearchFromStorage = (item, e) => {
		updateInputSearch(item.inputSearch)
		setValueAutocomplete(item.valueAutocomplete)
		setAutoCompleteRefresh(Math.floor(Math.random() * 10000))
		// submitSearchForm(e);
		setTimeout(function () {
			var searchButton = document.getElementById("searchButton")
			searchButton.click()
		}, 500)
		setSaveQueryData({ name: item.name, share: item.share, id: item.id })
		setShareRefresh(Math.random())
		let element = document.getElementById("clearButton")
		element.classList.remove("disabled")
		element.classList.add("showClearButton")
	}

	const loadSearchFromReducer = (item, e) => {
		try {
			let name = ""
			if (item.hasOwnProperty("search_name")) {
				name = item.search_name
			} else {
				name = item.name
			}

			updateInputSearch(item.params.text)
			if (item.params.categories.length > 0) {
				let arraySavedConcept = []
				item.params.categories.map((savedConcept) => {
					arraySavedConcept.push(savedConcept)
				})
				setValueAutocomplete(arraySavedConcept)
			} else {
				setValueAutocomplete([])
			}
			setAutoCompleteRefresh(Math.floor(Math.random() * 10000))
			setTimeout(function () {
				var searchButton = document.getElementById("searchButton")
				searchButton.click()
			}, 500)
			setSaveQueryData({
				name: name,
				share: item.params.published,
				id: item.search_id,
			})
			dispatch(setSelectedSearch(item))
			setShareRefresh(Math.random())
			let element = document.getElementById("clearButton")
			element.classList.remove("disabled")
			element.classList.add("showClearButton")
		} catch (error) {
			console.log(error)
		}
	}

	/* ******************* END CUSTOM FUNCTIONS ******************* */

	/* ******************* VARIABLES ******************* */
	let elementsPerPageSavedConcepts = 10
	// eslint-disable-next-line
	let calcTotalPagesSavedConcepts = Math.ceil(savedConceptList.length / elementsPerPageSavedConcepts)

	let elementsPerPageSharedConcepts = 10
	// eslint-disable-next-line
	let calcTotalPagesSharedConcepts = Math.ceil(savedConceptList.length / elementsPerPageSharedConcepts)

	if (inputLoadSearch) {
		elementsPerPageSavedConcepts = 1000
		// eslint-disable-next-line
		calcTotalPagesSavedConcepts = Math.ceil(savedConceptList.length / elementsPerPageSavedConcepts)

		elementsPerPageSharedConcepts = 1000
		// eslint-disable-next-line
		calcTotalPagesSharedConcepts = Math.ceil(savedConceptList.length / elementsPerPageSharedConcepts)
	}

	const classes = useStyles()

	const wrapperRef = useRef(null)
	const wrapperRefSave = useRef(null)
	useOutsideAlerter(wrapperRef)
	useOutsideAlerterSave(wrapperRefSave)
	/* ******************* END VARIABLES ******************* */

	return (
		<div className="container-fluid shadow my-3 p-2">
			<form className="px-2" onSubmit={submitSearchForm}>
				<input
					id="inputSearch"
					type="text"
					name="search"
					value={inputSearch}
					onChange={updateSearch}
					className=" mb-0 col-10 px-3 searchBar"
					placeholder={t("search.search_bar")}
					data-cy="search_search_input"
				/>

				<button
					id="searchButton"
					type="submit"
					className="btn btn-primary btnInputConcept"
					data-testid="search_button"
					data-cy="search_search_button"
				>
					{t("search.search")}
				</button>

				<button id="clearButton" type="button" className="btn btn-primary btnInputConcept" onClick={() => updateClearSearch(true)}>
					{t("search.clear")}
				</button>

				<div className="mt-3">
					<Row>
						<Col md={5}>
							<Autocomplete
								key={autoCompleteRefresh} // Bool, or whatever just change it to re-render the component
								multiple
								id="size-small-standard-multi"
								size="small"
								options={savedConceptList}
								getOptionLabel={(option) => option.description}
								defaultValue={valueAutocomplete}
								renderInput={(params) => (
									<TextField
										{...params}
										variant="standard"
										label={t("search.choose_concepts")}
										placeholder={t("search.concepts")}
									/>
								)}
								//value={valueAutocomplete}
								onChange={(event, newValue) => {
									setValueAutocomplete(newValue)
								}}
								inputValue={inputValueAutocomplete}
								data-cy="choose_concepts"
							/>
						</Col>
						<Col md={1}>
							<InfoDialog btninfo="searchContext" />
						</Col>
						<Col md={6}>
							<div className="col-md-2 offset-md-1 inline-block pr-0 v-top" ref={wrapperRef} id="load_concept">
								<button
									// style={{ display: lastSearch.length > 0 ? "block" : "none" }}
									style={lastSearch && lastSearch.length > 0 ? { display: "block" } : { display: "none" }}
									data-cy="load_button"
									className="btn btn-outline-primary btn-sm height-35 w100 min100"
									onClick={(e) => {
										e.preventDefault()
										setShowSavedList(!showSavedList)
										setTotalPagesSavedConcepts(calcTotalPagesSavedConcepts)
										setTotalPagesSharedConcepts(calcTotalPagesSharedConcepts)
									}}
								>
									{t("search.load_search")}
								</button>
								<SavedSearches
									showSavedList={showSavedList}
									lastSearch={lastSearch}
									showSaveQueryDetail={showSaveQueryDetail}
									loadSearchFromStorage={loadSearchFromStorage}
									setShowSavedList={setShowSavedList}
									setShowSaveQueryDetail={setShowSaveQueryDetail}
									setSearchDelete={setSearchDelete}
									loadSearchFromReducer={loadSearchFromReducer}
									setUpdateFiletypes={setUpdateFiletypes}
									setFilterList={setFilterList}
									filterList={filterList}
									setFileTypesRefresh={setFileTypesRefresh}
									setSaveQueryData={setSaveQueryData}
									saveQueryData={saveQueryData}
								/>
							</div>
							<div
								className="inline-block"
								// style={{ display: lastSearch.length > 0 ? "block" : "none" }}
								style={lastSearch && lastSearch.length > 0 ? null : { display: "none" }}
							>
								<InfoDialog btninfo="loadSavedSearch" />
							</div>
						</Col>
					</Row>
				</div>
				<SaveNewSearch
					saveQueryData={saveQueryData}
					setSaveQueryData={setSaveQueryData}
					shareRefresh={shareRefresh}
					setTotalPagesSavedConcepts={setTotalPagesSavedConcepts}
					calcTotalPagesSavedConcepts={calcTotalPagesSavedConcepts}
					setTotalPagesSharedConcepts={setTotalPagesSharedConcepts}
					calcTotalPagesSharedConcepts={calcTotalPagesSharedConcepts}
					// setSearchReducer={setSearchReducer}
					setShowToSaveForm={setShowToSaveForm}
					saveSearch={saveSearch}
					setShareRefresh={setShareRefresh}
				/>
			</form>
		</div>
	)
}

export default SearchBox
